import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

const EPContent = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: ref,
    bg: "background",
    display: {
      base: 'flex',
      md: 'initial'
    },
    flex: {
      base: '1',
      md: 'initial'
    },
    flexDirection: {
      base: 'column',
      md: 'initial'
    },
    px: {
      base: 'space50',
      lg: 'space80'
    },
    py: {
      base: 'space60',
      md: 'space70'
    }
  }, props), children);
});

export { EPContent };
